/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import GettingStartedPlaceholder from '../../assets/images/select-option-graphic.svg'
import DragnDropPlaceholder from '../../assets/images/drag-drop.svg'

import Question from '../../Question/Question'

@observer
class QuestionItemList extends PureComponent {
    constructor(props) {
        super(props)
        this.additionalQuestionsUrl = '/v1/dashboard/question'
        this.additionalQuestionsList = []
    }

    render() {
        const {
            store,
            dropContext,
            appStore,
            isDropDisabled,
            isFullSize,
            isQuestionLibrary,
            innerRef,
            allowInherit,
            questionIds,
        } = this.props
        const questionsList = isQuestionLibrary ? store.questionLibraryFilteredList : store.filteredList

        const filteredQuestionList = questionsList.filter((q) => {
            // questionsList from qList, questionIds from survey
            const searchId = q.questionId.toLowerCase()
            return !questionIds?.has(searchId)
        })

        const showImg = (!isQuestionLibrary && questionsList.length === 0)
        const showSecondInfo = (store.questionLibraryFilteredList.length > 0 && store.filteredList.length === 0)

        return (
            <div className={`q-dropzone ${showImg ? 'h-100' : ''}`} ref={innerRef}>
                <Droppable style={{ width: 'inherit', height: 'inherit' }} isDropDisabled={isDropDisabled} test={1} droppableId={dropContext}>
                    {(provided, snapshot) => (
                        <div className="questions-list" ref={provided.innerRef} {...provided.droppableProps}>
                            {filteredQuestionList.map((question, index) => (
                                <Draggable
                                    key={`${question.questionId}_${index}`}
                                    draggableId={`${question.questionId}_${index}`}
                                    id={`${question.questionId}_${index}`}
                                    index={index}
                                >
                                    {(provided, snapshot) => (
                                        <Question
                                            dropContext={dropContext}
                                            appStore={appStore}
                                            provided={provided}
                                            question={question}
                                            store={store}
                                            additionalQuestionsUrl={this.additionalQuestionsUrl}
                                            isFullSize={isFullSize}
                                            questionIndex={index}
                                            allowInherit={allowInherit}
                                        />
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                {showImg && (
                    <div className={`questions-placeholder-wrapper ${showSecondInfo ? 'drag-n-drop' : ''}`}>
                        <div className="questions-placeholder-content">
                            {showSecondInfo ? <img src={DragnDropPlaceholder} alt="Drag and drop placeholder" /> : <img src={GettingStartedPlaceholder} alt="Getting started placeholder" />}
                            {showSecondInfo ? <p className="placeholder-header drag-n-drop">{i18n.t('questionLibrary.editPanel.placeholderContent.stepTwo.title', 'Drag and drop')}</p> : <p className="placeholder-header">{i18n.t('dash_leftinfo1_title', 'Getting Started')}</p>}
                            {showSecondInfo ? (<p className="placeholder-content drag-n-drop">{i18n.t('questionLibrary.editPanel.placeholderContent.stepTwo.description', 'Drag and drop your required questions here')}</p>) : (<p className="placeholder-content">{i18n.t('questionLibrary.editPanel.placeholderContent', 'First select from the drop down your required event industry')}</p>)}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default QuestionItemList
